import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SalesCreditLimitContainerModel } from "../../../../../../models/aggregates/erp/credit";
import { Core2Config } from "../../shared/core2Config";
import { ApiResponseModel, ApiVisa } from "../../shared";
import { Observable } from "rxjs";
import { BaseApiPublicLoginTemplateService } from "../../shared/base-api-public-login-template.service";

@Injectable({ providedIn: "root" })
export class SalesCreditLimitService extends BaseApiPublicLoginTemplateService<SalesCreditLimitContainerModel, SalesCreditLimitContainerModel, SalesCreditLimitContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "fi/entity-sales-credit-limit/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "fi/entity-sales-credit-limit/backoffice-ep";

    this.endpoint_path_login_url =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "fi/entity-sales-credit-limit/login-ep";
    this.endpoint_path_login_entity_url =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "fi/entity-sales-credit-limit/login-entity-ep";
    this.httpClient = http;
  }

  postMultiEntitySalesCreditLimit(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + "/add-multi-credit-limit";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
